import { ButtonState } from "psims/react/components/button/button";
import { useMemo } from "react";
import { ViewMode } from "../../shared/use-view-mode";

import { UseImporterAnnualActivityAPI } from "./use-importer-annual-activity-api";
import { UseImporterAnnualActivityNavigation } from "./use-importer-annual-activity-navigation";
import { UseImporterAnnualActivityProgress } from "./use-importer-annual-activity-progress";

interface UseImporterAnnualActivityControlsProps {
    apiCtrl: UseImporterAnnualActivityAPI;
    navCtrl: UseImporterAnnualActivityNavigation;
    progressCtrl: UseImporterAnnualActivityProgress;
    viewMode: ViewMode;
}

function useImporterAnnualActivityControls({apiCtrl, navCtrl, progressCtrl, viewMode}: UseImporterAnnualActivityControlsProps) {
    const primaryControl = useMemo(() => {
        const {currentStep: {index, kind}} = progressCtrl;
        const nextStep = index + 1;
        const label = viewMode === 'edit' ?
            (kind === 'data' ? 'Save and continue' : 'Submit') :
            'Continue';
        const action = viewMode === 'edit' ? (kind === 'data' ?
                    () => navCtrl.saveAndGoToPage(nextStep) :
                    navCtrl.attemptSubmit
                ) :
                () => progressCtrl.goToStep(nextStep);
        const state: ButtonState = apiCtrl.isBusy ? 'loading' : 'normal';

        const isDisabled = apiCtrl.isBusy;

        const isShown = viewMode === 'edit' ? true : (
            kind !== 'submit'
        )

        return {
            action,
            isDisabled,
            isShown,
            label,
            state,
        }
    }, [apiCtrl, navCtrl, progressCtrl, viewMode]);

    const secondaryControl = useMemo(() => {
        const {currentStep: {index}} = progressCtrl;
        const nextStep = index - 1;
        const action = viewMode === 'edit' ?
            () => navCtrl.saveAndGoToPage(nextStep) :
            () => progressCtrl.goToStep(nextStep);

        const isDisabled = apiCtrl.isBusy;// || validationCtrl.notifications.length > 0;

        const isShown = index > 0;
        const label = 'Previous';
        const state: ButtonState = apiCtrl.isBusy ? 'loading' : 'normal';

        return {
            action,
            isDisabled,
            isShown,
            label,
            state,
        }
    }, [apiCtrl.isBusy, navCtrl, progressCtrl, viewMode]);

    return {
        primaryControl,
        secondaryControl,
    };
}

export default useImporterAnnualActivityControls
